import { createPanzoom } from '.';
import { queryAll, query } from '~/lib/utils/dom';
queryAll('.js-panzoom')
    .map((main) => ({
    main,
    openBtn: query('.js-panzoom-open-btn', main),
    closeBtn: query('.js-panzoom-close-btn', main),
    modalContainer: query('.js-panzoom-modal-container', main),
    modal: query('.js-panzoom-modal', main),
    frame: query('.js-panzoom-frame', main),
    img: query('.js-panzoom-img', main),
    zoomInBtn: query('.js-panzoom-zoom-in-btn', main),
    zoomOutBtn: query('.js-panzoom-zoom-out-btn', main),
}))
    .map(createPanzoom);
